"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerInput = exports.DatePickerContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledComponentsBreakpoint = _interopRequireDefault(require("styled-components-breakpoint"));

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var DatePickerInput = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n\n    ", ";\n"])), (0, _styledComponentsBreakpoint["default"])('laptop')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        width: auto;\n    "]))));

exports.DatePickerInput = DatePickerInput;

var DatePickerContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    .react-datepicker {\n        font-family: 'Poppins', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n    }\n\n    .react-datepicker-wrapper {\n        width: 100%;\n    }\n"])));

exports.DatePickerContainer = DatePickerContainer;